module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-548224c2.png";